module.exports = __webpack_public_path__ + "static/media/check.5b6f4739.svg";